import React, { useState } from 'react';
import startCase from 'lodash/startCase';
import moment from 'moment';

import { getLang } from '~/commons/helpers';
import { env } from '~/commons/config';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';

const api = '/api/core/quotations';

const ListQuotations = () => {
  const [createdDate, setCreatedDate] = useState(null);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'refCode', label: 'Quotation Number' },
          {
            value: 'status',
            label: 'Status',
            options: env.status.quotations.map((g) => ({
              value: g,
              label: startCase(g),
            })),
          },
          { value: 'issuedBy.name', label: 'Sales Name' },
          { value: 'customer.name', label: 'Customer' },
        ],
        api,
        sort: { createdAt: -1 },
        actions: {
          fileExport: true,
        },
        filter: {
          ...(createdDate && { createdAt: createdDate }),
        },
        cols: [
          {
            key: 'refCode',
            children: 'Quotation Number',
            sortable: true,
          },
          { key: 'status', sortable: true, getter: (v) => startCase(v) },
          {
            key: 'customer.name.full.en',
            children: 'Customer',
            sortable: true,
            getter: (v, r) => getLang(r.customer?.name?.full),
          },
          {
            key: 'issuedBy.name.full.en',
            children: 'Issued By',
            sortable: true,
            getter: (v, r) => getLang(r.issuedBy?.name?.full) || startCase(r.issuedBy?.username),
          },
          {
            key: 'issuedBy.salesRepId',
            children: 'Sales ID',
            sortable: true,
            getter: (v, r) => r.issuedBy?.salesRepId ?? '',
          },
          {
            key: 'createdAt',
            sortable: true,
            getter: (v) => (v ? moment(v).format(env.f.dt) : ''),
          },
        ],
      }}
    >
      {() => (
        <>
          <BtnDayRangePicker
            className="float-right"
            value={createdDate}
            onChange={setCreatedDate}
            placeholder={'Created At'}
          />
        </>
      )}
    </ListResource>
  );
};

export default ListQuotations;
